import { NavLinkProps, NavLink as RouterNavLink } from "react-router";

import { twMerge } from "tailwind-merge";

export const NavLink = ({ children, className, ...props }: NavLinkProps) => {
  return (
    <RouterNavLink
      className={(props) => {
        const cls =
          typeof className === "string" ? className : className?.(props);
        return twMerge(
          "text-fiord hover:text-fiord/50 focus:text-fiord/50 flex font-light transition-colors outline-none",
          props.isActive && "text-fiord pointer-events-none",
          cls
        );
      }}
      {...props}
    >
      {children}
    </RouterNavLink>
  );
};
